module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "height": "100%",
      "text-align": "center",
      "width": "100%",
      "z-index": "9999",
      "margin-top": "20vh"
    }
  }, [_c('div', {
    staticClass: "md-preloader"
  }, [_c('svg', {
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "version": "1.1",
      "height": "75",
      "width": "75",
      "viewbox": "0 0 75 75"
    }
  }, [_c('circle', {
    attrs: {
      "cx": "37.5",
      "cy": "37.5",
      "r": "33.5",
      "stroke-width": "4",
      "stroke": "#D7092E"
    }
  })])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-06bdd77a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/app/pages/superconciergerie/components/Loader.vue
// module id = 1313
// module chunks = 0